import getValueReduxUtil from 'modules/redux/utils/get-value'
import { DAY_KEY } from '@gymaholic/packages'

export const getWorkoutsDayUtil = day => {
  return getValueReduxUtil(day, DAY_KEY.WORKOUTS) || []
}
